import { useLocation, Link } from "react-router-dom"

function LinkItem({to_page, link_name}) {
    let locator = useLocation()
    
    const pathMatch = () => {
        if(to_page === locator.pathname){
            return true
        }
        return false
    }

  return (
    <Link className={pathMatch() ? 'current': ''} to={to_page}>{link_name}</Link>
  )
}

export default LinkItem